function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H1440V2289H0z",
  transform: "translate(-617 -861)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4DAEA",
  d: "M98.506 128.396c-15.267 7.915-39.67 7.688-54.508-.507-14.837-8.199-14.492-21.256.774-29.17 15.264-7.912 39.669-7.686 54.508.507 14.839 8.197 14.489 21.259-.774 29.17z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M107.461 84.197c.039-4.657-3.324-9.336-10.122-12.958-13.776-7.331-36.434-7.535-50.606-.456-7.277 3.635-10.9 8.486-10.842 13.33l-.001-.14c-.026 7.985-.052 20.307-.077 28.29-.014 4.644 3.35 9.304 10.125 12.91 13.776 7.331 36.433 7.534 50.607.453 7.201-3.598 10.827-8.386 10.844-13.187.023-7.984.05-20.304.075-28.29l-.003.048z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4DAEA",
  d: "M98.506 100.872c-15.267 7.917-39.67 7.688-54.508-.505-14.837-8.196-14.492-21.257.774-29.169 15.264-7.914 39.669-7.686 54.508.507 14.839 8.199 14.489 21.257-.774 29.167z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M107.461 56.715c.039-4.664-3.324-9.342-10.122-12.96-13.776-7.33-36.434-7.538-50.606-.454-7.277 3.635-10.9 8.483-10.842 13.33l-.001-.143c-.026 7.985-.052 20.304-.077 28.287-.014 4.645 3.35 9.305 10.125 12.911 13.776 7.333 36.433 7.536 50.607.458 7.201-3.6 10.827-8.389 10.844-13.192.023-7.98.05-20.302.075-28.29l-.003.053z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4DAEA",
  d: "M98.506 73.427c-15.267 7.914-39.67 7.685-54.508-.51-14.837-8.195-14.492-21.256.774-29.168 15.264-7.911 39.669-7.688 54.508.508 14.839 8.196 14.489 21.255-.774 29.17z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M107.461 29.23c.039-4.66-3.324-9.34-10.122-12.96-13.776-7.335-36.434-7.538-50.606-.456-7.277 3.634-10.9 8.485-10.842 13.333L35.89 29c-.026 7.984-.052 20.307-.077 28.289-.014 4.647 3.35 9.307 10.125 12.91 13.776 7.332 36.433 7.537 50.607.456 7.201-3.6 10.827-8.386 10.844-13.187.023-7.985.05-20.306.075-28.289l-.003.05z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4DAEA",
  d: "M98.506 45.905c-15.267 7.912-39.67 7.686-54.508-.51-14.837-8.196-14.492-21.253.774-29.17 15.264-7.912 39.669-7.685 54.508.51 14.839 8.196 14.489 21.255-.774 29.17z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M47.68 44.676c-2.506-1.136-4.34-2.312-5.518-3.48.559 1.337 2.294 2.754 5.237 4.082 4.577 2.067 11.07 3.467 17.437 3.967-6.396-.908-12.523-2.479-17.155-4.569zM47.68 72.72c-2.506-1.132-4.34-2.308-5.518-3.474.559 1.332 2.294 2.749 5.237 4.08 4.577 2.066 11.07 3.466 17.437 3.966-6.396-.906-12.523-2.478-17.155-4.571zM47.68 99.617c-2.506-1.13-4.34-2.31-5.518-3.479.559 1.34 2.294 2.755 5.237 4.085 4.577 2.065 11.07 3.469 17.437 3.969-6.396-.911-12.523-2.482-17.155-4.575zM47.68 127.394c-2.506-1.13-4.34-2.309-5.518-3.475.559 1.335 2.294 2.749 5.237 4.077 4.577 2.066 11.07 3.469 17.437 3.969-6.396-.908-12.523-2.481-17.155-4.571z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M43.92 46.264c-.291-.156-.572-.32-.851-.48V67.38c1.054.77 2.228 1.51 3.53 2.2 3.897 2.073 8.574 3.599 13.703 4.522V51.614c-6.02-1.002-11.677-2.785-16.381-5.35z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#515151",
  d: "M43.92 73.746c-.291-.158-.572-.317-.851-.48v21.598c1.054.775 2.228 1.51 3.53 2.201 3.897 2.073 8.574 3.602 13.703 4.523V79.099c-6.02-.997-11.677-2.783-16.381-5.353z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M43.92 101.261c-.291-.16-.572-.321-.851-.485v21.598c1.054.774 2.228 1.51 3.53 2.203 3.897 2.072 8.574 3.6 13.703 4.52v-22.486c-6.02-.997-11.677-2.784-16.381-5.35z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#99A4C2",
  d: "M96.61 42.653c-14.19 7.086-36.872 6.883-50.66-.455-13.79-7.343-13.47-19.04.718-26.129 14.189-7.087 36.869-6.883 50.658.455 13.794 7.345 13.471 19.042-.716 26.129z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  d: "M89.325 29.86h9.07v-1.075h-9.07v1.074z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  d: "M97.02 31.713c-1.796.945-4.667.917-6.413-.06-1.745-.978-1.703-2.538.091-3.488 1.797-.943 4.669-.915 6.412.065 1.747.975 1.707 2.538-.09 3.483z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M97.02 30.558c-1.796.944-4.667.914-6.413-.063-1.745-.981-1.703-2.541.091-3.486 1.797-.943 4.669-.917 6.412.06 1.747.978 1.707 2.54-.09 3.489z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M43.92 73.746c-.291-.158-.572-.317-.851-.48v21.598c1.054.775 2.228 1.51 3.53 2.201 3.897 2.073 8.574 3.602 13.703 4.523V79.099c-6.02-.997-11.677-2.783-16.381-5.353z"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H78V125H0z",
  transform: "translate(32.982 9.88)"
}));

function SvgDrum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    fill: "none",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrum);
export default __webpack_public_path__ + "static/media/drum.492dbcea.svg";
export { ForwardRef as ReactComponent };